{
  "pt": {
    "form": {
      "actions": {
        "cancel": "Cancelar",
        "clear": "Limpar",
        "closeFullPage": "Fechar página inteira",
        "copyText": "Clique para copiar o texto",
        "next": "Seguinte",
        "openFullPage": "Abrir em página inteira",
        "save": "Guardar",
        "saveChanges": "Guardar alterações",
        "search": "Pesquisar...",
        "send": "Enviar",
        "send_and_create_another": "Enviar e criar outro",
        "submit": "Enviar",
        "submit_and_create_another": "Submeter e criar outro"
      },
      "back": "Etapa anterior",
      "labels": {
        "columns": "Colunas",
        "no_results": "Sem resultados"
      },
      "notifications": {
        "textHasBeenCopied": "O texto foi copiado"
      },
      "password": "Palavra-passe",
      "shortcuts": {
        "save_mac": "⌘ + Enter para guardar",
        "save_windows": "Ctrl + Enter para guardar",
        "send_mac": "⌘ + Enter para enviar",
        "send_windows": "Ctrl + Enter para enviar"
      },
      "steps": "Passo {count} de {total}",
      "writeEmployeeNameReject": "Escreva <i><b>{employeeName}</b></i> para continuar."
    }
  }
}